import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  hide (event) {
    if (this.element.form.reportValidity()) {
      bootstrap.Offcanvas.getInstance(this.element.closest('.offcanvas')).hide();
    } else {
      event.preventDefault();
      return false;
    }
  }
}
